<template>
    <div class="search-wrapper">
<!--        <h3 class="title" v-if="title">{{title}}</h3>-->
        <Row>
            <Col :span="span" :class="{'mb16':multipleLines}">
                <slot></slot>
            </Col>
            <Col :span="btnSpan" :offset="btnOffset" :class="{'text-align-r':multipleLines, 'btn-inline': inline}">
                <Button type="primary" @click="searchData" class="btn-width mr8">搜索</Button><Button @click="restValue" type="ghost" class="btn-width">重置</Button>
            </Col>
        </Row>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: {
        title:{
            type:String,
            default:''
        },
        span:{
            type:Number,
            default:19
        },
        btnSpan:{
            type:Number,
            default:4
        },
        btnOffset:{
            type:Number,
            default:1
        },
        multipleLines:{
            type:Boolean,
            default:false
        },
        inline:{
            type:Boolean,
            default:false
        }
    },
    methods: {
        searchData() {
           this.$emit('search');
        },
        restValue() {
            this.$emit('clear')
        }
    }
}
</script>
